import { render, staticRenderFns } from "./Ipo.vue?vue&type=template&id=205d4888&scoped=true"
import script from "./Ipo.vue?vue&type=script&lang=js"
export * from "./Ipo.vue?vue&type=script&lang=js"
import style0 from "./Ipo.vue?vue&type=style&index=0&id=205d4888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205d4888",
  null
  
)

export default component.exports